class rebuyWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector('.product-rebuy-grid');
    this.template = this.querySelector('template');
    this.submitButton = this.querySelector('.product-rebuy-submit');
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
  renderProducts() {
    const requestParameters = new URLSearchParams({
      shopify_product_ids: this.dataset.ids,
      limit: this.dataset.limit,
      key: "e488a65ddd527f3b556185b468cb10e55a0b3da9"
    });

    fetch(this.dataset.url + requestParameters)
      .then(response => response.json())
      .then(data => {
        if (data.data.length) {
          for (const [index, product] of data.data.entries()) {
            if (product) {
              fetch(`${product.link}?view=rebuy-card`).then(resp => resp.text()).then(result => {
                if (result) {
                  this.targetElement.innerHTML += result;

                  if (index + 1 == data.data.length) {
                    setTimeout(() => {
                      this.eventHandlers();
                    }, 500);
                  }
                }
              });
            }
          }
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
  eventHandlers() {
    this.inputs = this.querySelectorAll('[name="id"]');

    this.priceAndItemsSubmitUpdate(this.inputs);

    this.submitButton.addEventListener('click', this.addToCartHandler.bind(this));

    let atcBtns = this.querySelectorAll('.product-form__buttons button');

    if (atcBtns) {
      for (const atcBtn of atcBtns) {
        atcBtn.classList.add('ready');
      }
    }
  }
  priceAndItemsSubmitUpdate(inputs) {
    let items = [];

    let wasPrice = 0;
    let totalPrice = 0;
    inputs.forEach((input) => {
      if (input.dataset.price) {
        totalPrice += (parseFloat(input.dataset.price) * 100)
        wasPrice += (parseFloat(input.dataset.compareAtPrice) * 100)
      }
      
      let item = {
        id: input.value,
        quantity: 1,
      };
      items.push(item)
    });

    this.items = items;

    // Update the total price in the widget footer
    this.querySelector('#product-rebuy-total').textContent = Shopify.formatMoney(totalPrice, '${{amount}}') != '$0' ? Shopify.formatMoney(totalPrice, '${{amount}}') : '';
    this.querySelector('#product-rebuy-was').textContent = Shopify.formatMoney(wasPrice, '${{amount}}') != '$0' ? Shopify.formatMoney(wasPrice, '${{amount}}') : '';
  }
  addToCartHandler(e) {
    this.priceAndItemsSubmitUpdate(this.inputs);

    e.preventDefault();

    var $addToCartBtn = $('.product-form__submit').first();
    let $addToCartForm = $('#product-form-main');

    let data = {
      items: this.items
    }

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      beforeSend: function() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function(itemData) {
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();

        console.error(response)
        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartForm.after(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        //$addToCartBtn.find('span').text(Shopify.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  }
}

customElements.define('rebuy-widget', rebuyWidget);